// extracted by mini-css-extract-plugin
export default {"layout":"AutoSearching_layout__MhoTZ","input":"AutoSearching_input__3PcdJ","itemBox":"AutoSearching_itemBox__Mzc2P","item":"AutoSearching_item__4u+-Q"};